import { CampaignPiece } from "@app/shared/models/campaignPiece";

export class Page {
  id:number;
  campaignPiece:CampaignPiece;
  height:number;
  pageText:string;
  prAttId:number;
  section:string;
  segmentIdentifier:string;
  segmentNumber:number;
  smallPrAttId:number;
  thAttId:number;
  uuid:string;
  width:number;
  x:number;
  xml:string;
  y:number;
  z:number
}

export class PageMenuEvent{
  type?:string;
  page?:Page;
}

export const PageMenuEventType = {
  EDIT_PAGE: 'EDIT_PAGE',
  ADD_PAGE: 'ADD_PAGE',
  DELETE_PAGE:'DELETE_PAGE',
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/page.ts